<template>
    <div class="md:tw-inline-block tw-relative">

        <button id="actionsMenuInboxButton" @click="isDropdownOpen = ! isDropdownOpen" class="cu-btn tw-relative tw-mb-1">
            <i class="fa fa-spinner fa-pulse tw-mr-1" v-show="isLoading"></i>
                Aktion
            <i class="fa fa-chevron-down tw-ml-1"></i>
        </button>

        <div id="myDropdown" style="min-width: 250px;"
             class="dropdown-content tw-bg-white tw-absolute tw-overflow-auto tw-z-20 tw-rounded-md tw-pt-2 tw-pb-2 tw-border tw-border-navbar-secondary tw-right-0"
             v-show="isDropdownOpen"
             v-closable="{
                exclude: ['#actionsMenuInboxButton'],
                handler: 'onClose'
            }"
        >

            <div class="tw-inline-flex tw-px-4 tw-mb-1 tw-container tw-flex-wrap">
                <div class="tw-w-full tw-mt-4">
                    <bordered-input>
                        <template #label>
                            <label for="date">
                                <template>
                                    Datum
                                </template>
                            </label>
                        </template>
                        <template #input>
                            <input type="date" id="date" v-model="date">
                        </template>
                    </bordered-input>

                    <div class="tw-w-full tw-mt-2">
                        <bordered-input>
                            <template #label>
                                <label for="fiBuNumber">
                                    <template>
                                        FiBu Nummer
                                    </template>
                                </label>
                            </template>
                            <template #input>
                                <input type="text" id="fiBuNumber" v-model="fiBuNumber">
                            </template>
                        </bordered-input>
                    </div>

                    <div class="tw-w-full tw-text-danger-primary tw-text-sm" v-if="!! this.validationErrors.date && this.validationErrors.date.length > 0">
                        {{ this.validationErrors.date[0] }}
                    </div>
                    <div class="tw-w-full tw-text-danger-primary tw-text-sm" v-if="!! this.validationErrors.fiBuNumber && this.validationErrors.fiBuNumber.length > 0">
                        {{ this.validationErrors.fiBuNumber[0] }}
                    </div>
                </div>
                <div @click="triggerPaidAction()" class="cu-btn tw-mt-2">Bezahlt</div>
            </div>
            
            <hr class="tw-my-2 tw-mr-0 tw-ml-0">

            <div class="tw-flex tw-flex-wrap">
                <button type="button" 
                    class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                    data-toggle="modal" data-target="#cancel-invoice-modal"
                >
                    <span>Storniert</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import BorderedInput from "../BorderedInput";
    import moment from "moment";

    export default {
        components: {
            BorderedInput,
        },

        props: {
            invoice_id: {
                required: true,
                type: String,
            },
        },

        data() {
            return {
                isDropdownOpen: false,
                isLoading: false,
                csrfToken: null,
                validationErrors: {},

                date: moment().format('YYYY-MM-DD'),
                fiBuNumber: null
            }
        },

        methods: {
            onClose() {
                this.isDropdownOpen = false;
            },
            triggerPaidAction() {
                this.isLoading = true;
                this.validationErrors = {};

                axios.post(('/invoices/admin/mark-as-paid/' + this.invoice_id) , { date: this.date, fiBuNumber: this.fiBuNumber })
                    .then(response => {
                        this.isLoading = false;
                        toast("Rechnung wurde als Bezahlt markiert.");
                        window.location.href = response.data.redirectTo;
                    })
                    .catch(error => {
                        if (!! error.response.data.errors) {
                            this.validationErrors = error.response.data.errors;
                        }
                    })
                    .then(() => {
                        this.isLoading = false;
                    });
            }
        },

        mounted() {
            this.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
        }
    }
</script>